<template>
  <div>
    <v-toolbar
      :absolute="true"
      flat
      class="toolbar"
    >
      <v-toolbar-title class="title">
        Orders
      </v-toolbar-title>
      <v-layout
        class="ml-4 ma-1"
        row
        wrap
      >
        <v-flex
          xs6
          class="mt-2"
        >
          <span class="white--text">
            On select search transactions by:
            <v-switch
              v-model="searchByOrderRef"
              dark
              :label="searchByOrderRef ? 'Reference' : 'Last name'"
              color="white"
              hide-details
            />
          </span>
        </v-flex>
        <v-flex xs6>
          <v-spacer />
          <v-text-field
            v-model="search"
            clearable
            append-icon="search"
            label="Search name and order reference..."
            dark
            color="white"
            class="searchField"
            @click:clear="clearSearch"
          />
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-layout
      wrap
      :style="{ maxHeight: containerHeight + 'px', overflow: 'auto'}"
    >
      <v-flex xs12>
        <v-flex
          class="listHeader pl-3 pt-3 grey--text"
          xs12
        >
          ({{ filteredOrders.length }}) Open
        </v-flex>
        <v-card>
          <v-flex
            v-for="(order) in filteredOrders"
            :key="order.id"
            xs12
          >
            <v-divider />
            <v-layout class="pa-2 pl-3">
              <v-flex xs2>
                <v-checkbox
                  :key="order.id"
                  v-model="selectedId"
                  color="#1A4C7D"
                  :checked="_selectedOrder && order.id === selectedId"
                  :value="order.id"
                  @change="selectOrder(order)"
                />
              </v-flex>
              <v-flex xs10>
                <v-layout>
                  <v-flex>
                    <div class="pt-1">
                      <b>{{ order.name }}</b>
                    </div>
                    <div class="pt-1">
                      <b class="grey--text">Reference:</b>
                      <span>{{ order.orderRef }}</span>
                    </div>
                    <div class="pt-1">
                      <b>Created at:</b>
                      <span>{{ formatDate(order.createdAt) }}</span>
                    </div>
                    <div class="pt-1">
                      <v-chip
                        small
                        label
                        color="#1A4C7D"
                        text-color="white"
                      >
                        <v-icon left>
                          attach_money
                        </v-icon>Amount:
                        <span>
                          <b>{{ order.amount | currency('€') }}</b>
                        </span>
                      </v-chip>
                    </div>
                  </v-flex>
                  <v-flex
                    xs3
                    text-xs-right
                  >
                    <v-btn
                      title="Show details"
                      icon
                      @click.stop="goToOrderDetails(order.id)"
                    >
                      <v-icon color="blue">
                        visibility
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import _ from 'lodash';

export default {
  name: 'OrdersList',
  props: {
    openOrders: {
      type: Array,
      default: () => ([]),
    },
    containerHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showList: true,
      selectedId: null,
      searchByOrderRef: true,
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.ebicsStore.orderSearch;
      },
      set: _.debounce(function setVal(val) {
        this.clearSelected();
        this.setOrderSearch(val);
      }, 800),
    },
    filteredOrders() {
      if (this.prepayOrders.length < 1) {
        this.clearSelected();

        return [];
      }
      const search = this.search ? this.search.toLowerCase() : '';
      if (!search) { return this.prepayOrders.slice(0, 100); }
      const result = this.prepayOrders.filter((order) => {
        if (!this._selectedOrder) { return this.filterSearchQuery(order, search); }

        return (
          order.id === this._selectedOrder.id ||
          this.filterSearchQuery(order, search)
        );
      });

      return result;
    },
    prepayOrders() {
      return this.openOrders.filter(order => order.type === 'prepay');
    },
    _selectedOrder() {
      return this.$store.state.ordersStore.selectedOrder;
    },
  },
  watch: {
    _selectedOrder(val) {
      this.selectedId = val ? val.id : null;
    },
  },
  methods: {
    ...mapMutations([
      'toggleOrders',
      'toggleTransactions',
      'updateOrdersAmount',
      'updateTransactionAmount',
      'setTransactionSearch',
      'setOrderSearch',
    ]),
    selectOrder(el) {
      if (!this.selectedId) {
        this.clearSelected();
        this.setTransactionSearch('');
      } else {
        if (this.searchByOrderRef) {
          this.setTransactionSearch(el.orderRef);
        } else {
          this.setTransactionSearch(el.name.split(' ').pop());
        }
        this.toggleOrders(el);
        this.updateOrdersAmount(parseFloat(el.amount));
      }
    },
    clearSelected() {
      this.updateOrdersAmount(0);
      this.toggleOrders(null);
    },
    clearSearch() {
      this.setOrderSearch('');
    },
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    filterSearchQuery(order, search) {
      return (
        (order.name !== undefined &&
          this.normalizeGermanCharacters(order.name).includes(
            this.normalizeGermanCharacters(search),
          )) ||
        (order.orderRef !== undefined &&
          order.orderRef
            .toLowerCase()
            .replace(/ /g, '')
            .includes(search.replace(/ /g, '')))
      );
    },
    goToOrderDetails(id) {
      this.$router.push({ name: 'order_detail', params: { id } });
    },
    normalizeGermanCharacters(val) {
      return val
        .toUpperCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036F]/g, '');
    },
  },

};
</script>

<style lang="scss" scoped>
.radioGroup {
  display: block;
  text-align: inherit;
  width: 100%;
}
.amountContainer {
  padding-top: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.toolbar {
  padding-top: 8px;
  position: sticky;
  background-color: #1a4c7d !important;
}
.searchField {
  color: white;
  max-width: 332px;
}
.title {
  color: white;
}
.listHeader {
  height: 48px;
  background-color: white;
}
a {
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/OrdersList.vue